import { Label } from "../../ui/label";
import { Textarea } from "../../ui/textarea";
import ExtraTechnicalSection from "../ExtraTechnicalSection";
import KiBadge from "../KiBadge";

/**
 * DescriptionAndTechnicalSection — wraps `ExtraTechnicalSection` and injects the
 * mandatory description textarea between the accessories and service blocks
 * (via the `descriptionNode` slot exposed by ExtraTechnicalSection).
 *
 * Extracted from CreateListingPage to keep the page below 1000 lines.
 *
 * Feb-2026 Iter 28 (User-Wunsch 25 May): Beschreibung & Service-Hinweise
 * sind jetzt EIN gemeinsames Feld (form.description). Char-Limit 4000.
 */
export default function DescriptionAndTechnicalSection({ form, update, setForm, isMoto, user, orderMode = false }) {
    return (
        <ExtraTechnicalSection
            form={form}
            update={update}
            setForm={setForm}
            isMoto={isMoto}
            user={user}
            orderMode={orderMode}
            descriptionNode={
                <div data-testid="description-block">
                    <Label className="text-xs font-bold uppercase tracking-wider text-gray-500 inline-flex items-center gap-1.5">
                        Beschreibung & Service-Hinweise <KiBadge field="description" />
                    </Label>
                    <Textarea
                        value={form.description}
                        onChange={(e) => update("description", e.target.value)}
                        rows={5}
                        maxLength={4000}
                        className="mt-1.5 rounded-sm"
                        placeholder="Zustand, Historie, Ausstattung, Highlights — UND Service-Hinweise: z. B. Zahnriemen neu, Inspektion bei autorisiertem Fachbetrieb, jüngste Reparaturen / Reifenwechsel, individuelle Hinweise…"
                        data-testid="form-description"
                    />
                    <p className="text-[11px] text-gray-500 mt-1">
                        {(form.description || "").length} / 4000 Zeichen
                    </p>
                </div>
            }
        />
    );
}
